"use client";
import React, { useRef } from "react";
import logoImg from 'assets/images/ssgk/ssgk-logo.png';
import html2canvas from 'html2canvas';

function MainComponent() {
  const cardRef = useRef(null);
  const cardWidth = "w-[3.375in]";
  const cardHeight = "h-[2.125in]";
  const user = JSON.parse(localStorage.getItem("user"))
  const userProfileImage = process.env.REACT_APP_API_BASE_URL +'/get-image?objectKey='+ user?.profile_image||'https://www.gravatar.com/avatar/?d=mp'
  const [imageLoaded, setImageLoaded] = React.useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleDownload = async () => {
    if (cardRef.current) {
      try {
        // Wait for image to be loaded
        if (!imageLoaded) {
          console.log("Waiting for image to load...");
          return;
        }

        const canvas = await html2canvas(cardRef.current, {
          scale: 2, // Higher scale for better quality
          backgroundColor: null,
          logging: false,
          useCORS: true, // Enable CORS for images
          allowTaint: true, // Allow cross-origin images
        });

        const image = canvas.toDataURL("image/png");
        console.log(image)
        const link = document.createElement("a");
        link.href = image;
        link.download = `${user?.first_name}_${user?.last_name}_ID_Card.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading card:", error);
      }
    }
  };

  return (
    <div className="p-8 bg-gray-100 space-y-8">
      <div ref={cardRef}>
        <div
          className={`${cardWidth} ${cardHeight} rounded-lg shadow-lg relative overflow-hidden border-2 border-[#D4AF37]`}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-gray-50 via-white to-[#F5F5F5] opacity-90"></div>

          <div className="relative z-10 h-full p-4">
            <div className="flex items-center justify-between mb-3">
              <img
                src={logoImg}
                alt="School Logo"
                className="h-8 w-auto object-contain"
              />
              <div className="text-right">
                <h1 className="text-sm font-bold text-gray-900"></h1>
                <p className="text-[10px] text-[#D4AF37] font-medium">

                </p>
              </div>
            </div>

            <div className="flex gap-3">
              <div className="w-20 h-24 bg-gradient-to-b from-gray-50 to-white rounded-lg overflow-hidden ring-2 ring-[#D4AF37]">
                {user?.profile_image ? (
                  <img
                    src={userProfileImage}
                    alt="Alumni photo"
                    className="w-full h-full object-cover"
                    onLoad={handleImageLoad}
                    crossOrigin="anonymous"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <i className="fas fa-user text-[#D4AF37] text-2xl"></i>
                  </div>
                )}
              </div>

              <div className="flex-1 space-y-1">
                <h2 className="text-sm font-bold text-gray-900">{user?.first_name} {user?.last_name}</h2>
                <p className="text-xs text-[#D4AF37] font-semibold flex items-center gap-1">

                </p>
                <p className="text-xs text-gray-600"></p>
                <p className="text-xs text-gray-600">Passout Batch: {user?.grad_year}</p>
                <p className="text-xs font-mono text-[#D4AF37]">
                  School Number: {user?.school_num}
                </p>
              </div>
            </div>

            <div className="absolute bottom-3 left-4 right-4">
              <div className="flex items-end justify-between">
                {/* <div className="space-y-1">
                  <div className="text-[10px] text-[#D4AF37]">Valadity</div>
                  <div className="text-xs">
                    <span className="font-medium">Lifetime</span>
                  </div>
                </div> */}

                {/* {qrCode && (
                  <img
                    src={qrCode}
                    alt="Alumni Portal QR Code"
                    className="w-12 h-12 object-contain"
                  />
                )} */}
              </div>
            </div>

            <div className="absolute top-2 right-2">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#D4AF37]/10 to-transparent flex items-center justify-center">
                <i className="fas fa-shield-alt text-[#D4AF37] text-sm"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-4">
        <button
          onClick={handleDownload}
          className="bg-[#D4AF37] text-white px-6 py-2 rounded-lg hover:bg-[#C5A028] transition-colors duration-300 flex items-center gap-2"
        >
          <i className="fas fa-download"></i>
          Download ID Card
        </button>
      </div>
    </div>
  );
}

export function ICard() {
  return (
    <div className="p-8 bg-gray-100 space-y-8">
      <MainComponent />
    </div>
  );
}

export default MainComponent;